import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

/**
 * @file Created on Fri Oct 26 2018
 * @author PKr
 * @author Tomáš Leity
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { EntityChangeConverter, EntityChangeSetInfoConverter, jsonConversions, LockActionResultConverter, WindowConverter, WindowImportResultConverter, PortionDTOConverter, WindowOverviewDTOConverter, WindowStatusConverter, WindowCopyResultDTOConverter, WindowMoveResultDTOConverter, ResultWithOverviewConverterImpl, WindowActionContextConverter, WindowFilterConverterImpl } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CRUTransportLayer } from '../CRUTransportLayer';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import logger from '../../logger';
export var WindowLayer =
/*#__PURE__*/
function (_CRUTransportLayer) {
  _inherits(WindowLayer, _CRUTransportLayer);

  function WindowLayer() {
    var _this;

    _classCallCheck(this, WindowLayer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowLayer).call(this, CONSTANTS.API.ENDPOINTS.WINDOW));
    /**
     * Gets all filtered Windows based on the filter.
     * @param overview
     * @param forUser
     * @returns Promise with fetched Windows.
     */

    _this.filter = function (overview) {
      var forUser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var resultWithOverviewConverter;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                resultWithOverviewConverter = new ResultWithOverviewConverterImpl(this.windowConverter, new WindowFilterConverterImpl());
                return _context.abrupt("return", api(CONSTANTS.API.ENDPOINTS.WINDOW_FILTER(forUser)).post({
                  overview: overview
                }, {
                  responseType: 'json'
                }).then(function (response) {
                  return resultWithOverviewConverter.toObject(response.data, jsonConversions);
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };
    /**
     * Get all similar windows based on windowId
     * @param windowId
     * @param sessionId
     * @returns Promise with fetched Windows.
     */


    _this.similarWindows = function (windowId, sessionId) {
      return api(sessionId ? "".concat(CONSTANTS.API.ENDPOINTS.WINDOW_SIMILAR(windowId), "?sessionId=").concat(sessionId) : CONSTANTS.API.ENDPOINTS.WINDOW_SIMILAR(windowId)).get({
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this.getConverter().toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };
    /**
     * Deletes one particular item based on Window id
     * @param id
     */


    _this.delete = function (id) {
      return api(CONSTANTS.API.ENDPOINTS.WINDOW_SINGLE(id)).delete().then(function () {
        return Promise.resolve();
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };
    /**
     * Imports windows from provided file
     * @param promotionId
     * @param file
     */


    _this.importWindows = function (promotionId, file) {
      var data = new FormData();
      data.append('dataFile', file.data);
      data.append('promotionId', promotionId);
      return api(CONSTANTS.API.ENDPOINTS.IMPORT_WINDOWS).post(data, {
        responseType: 'json'
      }).then(function (response) {
        return response.data.result.id;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };

    _this.importResult = function (processId) {
      return api(CONSTANTS.API.ENDPOINTS.IMPORT_WINDOWS_RESULT(processId)).get({
        responseType: 'json'
      }).then(function (response) {
        return _this.windowImportResultConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };
    /**
     * Locks one particular item based on Window id
     * @param id
     */


    _this.lockWindow = function (id) {
      return api(CONSTANTS.API.ENDPOINTS.WINDOW_LOCK(id)).post({}, {
        responseType: 'json'
      }).then(function (response) {
        return _this.lockActionResultConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };
    /**
     * Unlocks one particular item based on Window id
     * @param id
     * @param clearSession
     */


    _this.unlockWindow = function (id) {
      var clearSession = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return api(clearSession ? "".concat(CONSTANTS.API.ENDPOINTS.WINDOW_UNLOCK(id), "?clear=true") : CONSTANTS.API.ENDPOINTS.WINDOW_UNLOCK(id)).post({}, {
        responseType: 'json'
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };
    /**
     * Gets overview of WIndows based on filter
     * @param overview
     */


    _this.overview = function (overview) {
      return api(CONSTANTS.API.ENDPOINTS.WINDOW_OVERVIEW).post({
        overview: overview
      }, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this.windowOverviewDTOConverter.toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };
    /**
     * Gets change history set info based on windowId
     * @param windowId
     */


    _this.changeHistory = function (windowId) {
      return api(CONSTANTS.API.ENDPOINTS.WINDOW_CHANGE_HISTORY(windowId)).get({
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this.entityChangeSetConverter.toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };
    /**
     * Gets change history set based on windowId & setId
     * @param windowId
     * @param setId
     */


    _this.changeHistorySet = function (windowId, setId) {
      return api(CONSTANTS.API.ENDPOINTS.WINDOW_CHANGE_HISTORY_SET(windowId, setId)).get({
        responseType: 'json'
      }).then(function (response) {
        return (response.data.result || []).map(function (item) {
          return _this.entityChangeConverter.toObject(item, jsonConversions);
        });
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    };

    return _this;
  }

  _createClass(WindowLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.windowConverter;
    }
  }, {
    key: "getStatusConverter",
    value: function getStatusConverter() {
      return this.windowStatusConverter;
    }
    /**
     * Create copy process
     * @param windowId
     * @param promotionId
     * @returns id of progress monitor ( though endpoint returns whole {@link ProgressMonitorIdentity} object )
     */

  }, {
    key: "createCopyProcess",
    value: function createCopyProcess(windowId, promotionId) {
      return api(CONSTANTS.API.ENDPOINTS.WINDOW_COPY).post({
        windowId: windowId,
        promotionId: promotionId
      }, {
        responseType: 'json'
      }).then(function (response) {
        return response.data.result.id;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Get copy process result
     * @param processId
     */

  }, {
    key: "copyProcessResult",
    value: function copyProcessResult(processId) {
      var _this2 = this;

      return api(CONSTANTS.API.ENDPOINTS.WINDOW_COPY_RESULT(processId)).get({
        responseType: 'json'
      }).then(function (response) {
        return _this2.windowCopyResultConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Create move process for selected Window
     * @param windowId
     * @param promotionId
     * @returns id of progress monitor ( though endpoint returns whole {@link ProgressMonitorIdentity} object )
     */

  }, {
    key: "createMoveProcess",
    value: function createMoveProcess(windowId, promotionId) {
      return api(CONSTANTS.API.ENDPOINTS.WINDOW_MOVE).post({
        windowId: windowId,
        promotionId: promotionId
      }, {
        responseType: 'json'
      }).then(function (response) {
        return response.data.result.id;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Get move process status
     * @param processId
     */

  }, {
    key: "moveProcessResult",
    value: function moveProcessResult(processId) {
      var _this3 = this;

      return api(CONSTANTS.API.ENDPOINTS.WINDOW_MOVE_RESULT(processId)).get({
        responseType: 'json'
      }).then(function (response) {
        return _this3.windowMoveResultConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Move selected Window - confirm
     * @param sourceWindowId
     * @param targetWindowId
     */

  }, {
    key: "moveWindowConfirm",
    value: function moveWindowConfirm(sourceWindowId, targetWindowId) {
      return api(CONSTANTS.API.ENDPOINTS.WINDOW_MOVE_CONFIRM).post({
        sourceWindowId: sourceWindowId,
        targetWindowId: targetWindowId
      }, {
        responseType: 'json'
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Move selected Window - cancel
     * @param sourceWindowId
     * @param targetWindowId
     */

  }, {
    key: "moveWindowCancel",
    value: function moveWindowCancel(sourceWindowId, targetWindowId) {
      return api(CONSTANTS.API.ENDPOINTS.WINDOW_MOVE_CANCEL).post({
        sourceWindowId: sourceWindowId,
        targetWindowId: targetWindowId
      }, {
        responseType: 'json'
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Copy selected Window - confirm
     * @param sourceWindowId
     * @param targetWindowId
     */

  }, {
    key: "copyWindowConfirm",
    value: function copyWindowConfirm(sourceWindowId, targetWindowId) {
      return api(CONSTANTS.API.ENDPOINTS.WINDOW_COPY_CONFIRM).post({
        sourceWindowId: sourceWindowId,
        targetWindowId: targetWindowId
      }, {
        responseType: 'json'
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Copy selected Window - cancel
     * @param sourceWindowId
     * @param targetWindowId
     */

  }, {
    key: "copyWindowCancel",
    value: function copyWindowCancel(sourceWindowId, targetWindowId) {
      return api(CONSTANTS.API.ENDPOINTS.WINDOW_COPY_CANCEL).post({
        sourceWindowId: sourceWindowId,
        targetWindowId: targetWindowId
      }, {
        responseType: 'json'
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Gets workflow states of specific window
     * @param windowId
     */

  }, {
    key: "workflowState",
    value: function workflowState(windowId) {
      var _this4 = this;

      return api(CONSTANTS.API.ENDPOINTS.WINDOW_WORKFLOW_STATE(windowId)).get().then(function (response) {
        return _this4.getStatusConverter().toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Gets workflow states of specific windows
     * @param windowIds
     */

  }, {
    key: "workflowStates",
    value: function workflowStates(windowIds) {
      var _this5 = this;

      return api(CONSTANTS.API.ENDPOINTS.WINDOW_WORKFLOW_STATES).post({
        ids: windowIds
      }, {
        responseType: 'json'
      }).then(function (response) {
        return (response.data.result || []).map(function (item) {
          return _this5.getStatusConverter().toObject(item, jsonConversions);
        });
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
    /**
     * Gets window detail for user from session if existed
     * @param windowId
     */

  }, {
    key: "getEditedWindow",
    value: function getEditedWindow(windowId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this6 = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", api(CONSTANTS.API.ENDPOINTS.WINDOW_EDITED(windowId)).get({
                  responseType: 'json'
                }).then(function (response) {
                  return _this6.getConverter().toObject(response.data, jsonConversions);
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
    /**
     * Calls one of the Window actions
     * @param windowActionContexts
     */

  }, {
    key: "action",
    value: function action(windowActionContexts) {
      var _this7 = this;

      return api(CONSTANTS.API.ENDPOINTS.WINDOW_ACTION).post(windowActionContexts.map(function (a) {
        return _this7.windowActionContextConverter.toDocument(a, jsonConversions);
      }), {
        responseType: 'json'
      });
    }
  }, {
    key: "getSimulatedWindow",
    value: function getSimulatedWindow(originalWindowId) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _this8 = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", api(CONSTANTS.API.ENDPOINTS.WINDOW_SIMULATED(originalWindowId)).get({
                  responseType: 'json'
                }).then(function (response) {
                  if (response.data) {
                    return _this8.getConverter().toObject(response.data, jsonConversions);
                  } else {
                    return undefined;
                  }
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    }
    /**
     * Sends updated {@link Window} and returns updated one.
     *
     * @param window
     * @param sessionId
     */

  }, {
    key: "update",
    value: function update(window) {
      var _this9 = this;

      var sessionId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var apiConfig = {
        responseType: 'json'
      };
      var windowDocument = this.windowConverter.toDocument(window, jsonConversions);
      return api(CONSTANTS.API.ENDPOINTS.WINDOW_UPDATE(window.id, sessionId)).put(windowDocument, apiConfig).then(function (response) {
        return _this9.windowConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "updateWorkflowNote",
    value: function updateWorkflowNote(windowId, workflowNote, sessionId) {
      var _this10 = this;

      return api(CONSTANTS.API.ENDPOINTS.WINDOW_UPDATE_WF_NOTE(windowId, sessionId)).post({
        workflowNote: workflowNote
      }).then(function (response) {
        return _this10.windowConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }]);

  return WindowLayer;
}(CRUTransportLayer);

__decorate([Inject, __metadata("design:type", WindowConverter)], WindowLayer.prototype, "windowConverter", void 0);

__decorate([Inject, __metadata("design:type", WindowOverviewDTOConverter)], WindowLayer.prototype, "windowOverviewDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", WindowStatusConverter)], WindowLayer.prototype, "windowStatusConverter", void 0);

__decorate([Inject, __metadata("design:type", WindowImportResultConverter)], WindowLayer.prototype, "windowImportResultConverter", void 0);

__decorate([Inject, __metadata("design:type", WindowCopyResultDTOConverter)], WindowLayer.prototype, "windowCopyResultConverter", void 0);

__decorate([Inject, __metadata("design:type", WindowMoveResultDTOConverter)], WindowLayer.prototype, "windowMoveResultConverter", void 0);

__decorate([Inject, __metadata("design:type", LockActionResultConverter)], WindowLayer.prototype, "lockActionResultConverter", void 0);

__decorate([Inject, __metadata("design:type", EntityChangeConverter)], WindowLayer.prototype, "entityChangeConverter", void 0);

__decorate([Inject, __metadata("design:type", EntityChangeSetInfoConverter)], WindowLayer.prototype, "entityChangeSetConverter", void 0);

__decorate([Inject, __metadata("design:type", WindowActionContextConverter)], WindowLayer.prototype, "windowActionContextConverter", void 0);

__decorate([Inject, __metadata("design:type", PortionDTOConverter)], WindowLayer.prototype, "portionConverter", void 0);